import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestsService } from "../../../shared/services/requests.service";
import { RequestCategoryService } from "../../../shared/services/request-categoty.service";
import { forkJoin, Subject } from "rxjs";
import { RequestCategotyWithTypesModel } from "../../../shared/models/request/request-categoty-with-types-model";
import { UsersService } from "../../../admin/users/users.service";
import { UserEngineerDto } from "../../../shared/models/User/user-engineer.dto";
import { PlannedRequestDto } from "../../../shared/models/request/planned-request.dto";
import { PlanningMapComponent } from "../components/planning-map/planning-map.component";
import { AppService } from "../../../app.service";
import { PlanningMapMenuComponent } from "../components/planning-map-menu/planning-map-menu.component";
import { MapPointStatesEnum } from "../components/planning-map/map-point-states.enum";
import { Guid } from "guid-typescript";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { LookupService } from "../../../shared/services/lookup.service";
import { DialogService } from "@progress/kendo-angular-dialog";
import { IPlanningMapVisitContext, PlanningMapVisitComponent } from "../components/planning-map-visit/planning-map-visit.component";
import { CreateCustomerObjectComponent } from "../../../shared/components/customer-object/create-customer-object/create-customer-object.component";
import { CustomerObjectWithContactsDto } from "../../../shared/models/customerObject/customer-object-with-contacts.dto";
import { ActivitiesService } from "../../../shared/services/activities.service";
import { PlanningService } from "../../../shared/services/planning.service";
import { ActionDataResult } from "../../../shared/models/core/ActionDataResult";
import { PlanningResultDto } from "../../../shared/models/planning/planning-result-dto";
import { PlanningAutoMapComponent } from "../components/planning-auto-map/planning-auto-map.component";
import { Router } from "@angular/router";
import { NotificationService } from "../../../core/services/notification.service";
import { NotificationType } from "../../../core/services/notification-type";
import { AlgoritmType } from "../../../constants/planning.constants";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { UserGeoTrackDto } from "../../../shared/models/User/user-geo-track.dto";
import { GeoService } from "../../../shared/services/geo.service";
import { GetUsersGeoTracksRequest } from "../../../shared/models/User/get-users-geo-tracks.request";

@Component({
	selector: 'planning-requests-map-page',
	templateUrl: './planning-requests-map.page.html',
	styleUrls: [
		'./planning-requests-map.page.scss',
		'../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../vendor/libs/ngx-contextmenu/ngx-contextmenu.scss',
	],
	encapsulation: ViewEncapsulation.None
})
export class PlanningRequestsMapPage implements OnInit {

	@ViewChild('planningMapComponent') planningMapComponent: PlanningMapComponent;
	@ViewChild('planningMapMenuComponent') planningMapMenuComponent: PlanningMapMenuComponent;

	requestCategories: RequestCategotyWithTypesModel[] = [];
	serviceCenters: KeyValueObject[] = [];
	userEngineers: UserEngineerDto[] = [];
	requestUserEngineers: UserEngineerDto[] = [];
	requests: PlannedRequestDto[] = [];
	tracks: UserGeoTrackDto[] = [];

	selectedPlannedDay: Date;
	selectedRequestCategoryIds: number[] = [];
	selectedServiceCenterId: number;
	selectedUserIds: number[] = [];
	lastPlanningResult: PlanningResultDto;

	menuDataLoaded: boolean = false;
	loading: boolean = false;
	planningLoading: boolean = false;
	planningMode: boolean = false;
	confirmPlanningLoading: boolean = false;

	showRoutes: boolean = false;

	constructor(
		private activitiesService: ActivitiesService,
		private requestsService: RequestsService,
		private requestCategoriesService: RequestCategoryService,
		private usersService: UsersService,
		private planningService: PlanningService,
		private appService: AppService,
		private lookupService: LookupService,
		private dialogService: DialogService,
		private ngZone: NgZone,
		private router: Router,
		private notificationService: NotificationService,
		private geoService: GeoService,
		private changeDetector: ChangeDetectorRef
	) { }

	ngOnInit(): void {
		const requestCategories$ = this.requestCategoriesService.getRequestCategoriesWithTypes();
		const userEngineers$ = this.usersService.getUserEngineers();
		const serviceCenters$ = this.lookupService.getData('service-centers', null);

		forkJoin([requestCategories$, userEngineers$, serviceCenters$])
			.subscribe(([requestCategories, userEngineers, serviceCenters]) => {
				this.requestCategories = requestCategories;
				this.userEngineers = userEngineers;
				this.serviceCenters = serviceCenters;
				this.menuDataLoaded = true;
			});

		document.addEventListener(
			"visibilitychange", () => {
				if (!document.hidden && this.selectedPlannedDay != null) {
					this.loadRequests(this.selectedPlannedDay);
				}
			}
		);
	}

	getUtcDate(date: Date): Date {
		const now = new Date();
		return new Date(date.getTime() + now.getTimezoneOffset() * 60000)
	}

	changeShowRoutes(showRoutes: boolean) {
		this.showRoutes = showRoutes;

		this.changeDetector.detectChanges();
	}

	loadRequests(plannedDate: Date, enablePlannedRequests: boolean = false) {
		this.tracks = [];
		this.selectedPlannedDay = plannedDate;
		this.loading = true;

		this.requestsService.getRequestsTotalTime({
			date: this.selectedPlannedDay,
			activityInfo: null,
			userIds: this.userEngineers.map(u => u.userId)
		}).subscribe(workTimeResp => {
			this.requestsService.getPlannedRequests(plannedDate).subscribe(plannedResp => {
				this.requests = plannedResp.data;
				this.requests.forEach(x => x.uid = Guid.create().toString());

				let tracksRequest = new GetUsersGeoTracksRequest();
				tracksRequest.userIds = this.requests.filter(f => !!f.requestPerformerUserId).map(u => u.requestPerformerUserId);
				tracksRequest.date = this.selectedPlannedDay;
				this.geoService.getUsersGeoTracks(tracksRequest).subscribe(tracksRes => {
					if (tracksRes.isSuccessful) {
						if (tracksRes.data && tracksRes.data.length > 0) {
							this.tracks = tracksRes.data;
						}
					}

					if (workTimeResp.isSuccessful) {
						this.userEngineers = this.userEngineers.map(u => ({
							...u,
							workTimeInMinutes: workTimeResp.data.find(x => x.userId === u.userId).totalTimeInMinutes
						}));
					}

					this.refreshRequestUserEngineers();
					this.refreshRequests(enablePlannedRequests);
					this.loading = false;
				});
			});
		});
	}

	refreshRequestUserEngineers() {
		const requestEngineerIds = this.requests.filter(x => x.requestPerformerUserId != null).map(x => x.requestPerformerUserId);
		this.requestUserEngineers = this.userEngineers.filter(x => requestEngineerIds.some(id => x.userId == id));
	}

	changeEngineers(userIds: number[] = []) {
		this.selectedUserIds = userIds;
		this.refreshRequests();
	}

	changeRequestCategories(requestCategoryIds: number[] = []) {
		this.selectedRequestCategoryIds = requestCategoryIds;
		this.refreshRequests();
	}

	changeServiceCenter(serviceCenterId: number) {
		this.selectedServiceCenterId = serviceCenterId;
		this.refreshRequests();
	}

	filterRequestsFromPerformerUser(userId: number) {
		this.planningMapMenuComponent.forceSetUserEngineer(userId);
		this.selectedUserIds = [userId];
		this.refreshRequests();
	}

	refreshRequests(enablePlannedRequests: boolean = false) {
		if (enablePlannedRequests) {
			this.requests.filter(x => x.requestPerformerUserId != null).forEach(x => x.mapPointState = MapPointStatesEnum.enabled);
		}
		if (this.selectedRequestCategoryIds.length == 0 &&
			this.selectedServiceCenterId == null &&
			this.selectedUserIds.length == 0) {
			this.requests.forEach(x => x.mapPointState = MapPointStatesEnum.enabled);
		}
		else {
			let filteredRequests = this.requests;

			if (this.selectedRequestCategoryIds.length != 0) {
				filteredRequests = filteredRequests.filter(x => this.selectedRequestCategoryIds.some(c => c == x.requestCategoryId));
			}
			if (this.selectedServiceCenterId != null) {
				filteredRequests = filteredRequests.filter(x => x.serviceCenterId == this.selectedServiceCenterId);
			}

			if (this.selectedUserIds.length > 0) {
				if (this.selectedUserIds.some(x => x == 0)) {
					filteredRequests = filteredRequests.filter(x =>
						x.requestPerformerUserId == null ||
						this.selectedUserIds.some(u => u == x.requestPerformerUserId));
				}
				else {
					filteredRequests = filteredRequests.filter(x => this.selectedUserIds.some(u => u == x.requestPerformerUserId));
				}
			}

			this.requests.forEach(r => {
				const filtered = filteredRequests.some(f => f.uid == r.uid);
				r.mapPointState = filtered ? MapPointStatesEnum.enabled : MapPointStatesEnum.disabled;
			});
		}

		this.planningMapComponent.refreshRequests(this.requests);
		this.planningMapComponent.refreshTracks(this.tracks);
	}

	startPlanning() {
		/*if (this.selectedRequestCategoryIds.length !== 1) {
			this.notificationService.error({
				title: 'Ошибка',
				message: 'Для выполнения автоназначения необходимо выбрать одну линейку продукции.',
				notificationType: NotificationType.SweetAlert
			});

			return;
		}*/

		let categories = [];

		if (this.selectedRequestCategoryIds.length > 0) {
			const categoriesState: DataSourceRequestState = { skip: 0, take: null, filter: { logic: "or", filters: [] } };

			this.selectedRequestCategoryIds.forEach(f => {
				categoriesState.filter.filters.push({ field: "Id", operator: "eq", value: f });
			})

			this.lookupService.getData("request-categories", categoriesState).subscribe(data => {
				categories = data;

				this.processPlanning(categories);
			});
		} else {
			this.processPlanning(null);
		}

	}

	processPlanning(categories: KeyValueObject[]) {
		let cancelCheckPlanning$ = new Subject<void>();
		this.planningService.checkPlanning(this.selectedPlannedDay, [], this.selectedServiceCenterId, false, cancelCheckPlanning$).subscribe(res => {
			if (res.isSuccessful) {
				this.ngZone.run(() => {
					const dialogRef = this.dialogService.open({
						title: 'Автоназначение',
						content: PlanningAutoMapComponent,
						height: '90%',
						width: '90%'
					});

					const dialog = <PlanningAutoMapComponent>dialogRef.content.instance;

					dialog.userEngineers = this.userEngineers;
					dialog.userEngineers = this.userEngineers;
					dialog.requestUserEngineers = this.requestUserEngineers;
					dialog.requests = this.requests.filter(f => !f.isFinal);
					dialog.selectedPlannedDay = this.selectedPlannedDay;
					dialog.selectedRequestCategoryIds = this.selectedRequestCategoryIds;
					dialog.selectedServiceCenterId = this.selectedServiceCenterId;
					dialog.selectedUserIds = this.selectedUserIds;
					dialog.lastPlanningResult = this.lastPlanningResult;
					dialog.menuDataLoaded = this.menuDataLoaded;
					dialog.planningMode = true;
					dialog.planningLoading = true;
					dialog.categories = categories;

					dialog.cancelPlanningEvent.subscribe(() => {
						dialogRef.close();
					});
					dialog.continueEvent.subscribe(() => {
						dialogRef.close();
						this.loadRequests(this.selectedPlannedDay, true);
					});
				});
			} else {
				this.notificationService.error({
					title: 'Ошибка',
					message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
					notificationType: NotificationType.SweetAlert
				});
			}
		}, () => {
			this.notificationService.error({
				title: 'Ошибка',
				message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
				notificationType: NotificationType.SweetAlert
			});

			cancelCheckPlanning$.next();
		});
	}

	cancelPlanningMode() {
		this.requests.forEach(x => x.mapPointState = MapPointStatesEnum.default);
		this.planningMapComponent.refreshRequests(this.requests);
		this.planningMapComponent.refreshTracks(this.tracks);
		this.planningMode = false;
	}

	confirmPlanning() {
		this.confirmPlanningLoading = true;
		this.planningService.confirmPlanning(this.lastPlanningResult, true).subscribe(() => {
			this.confirmPlanningLoading = false;
			this.planningMode = false;
			this.refreshRequests();
		});
	}

	setVisitDate(requestId: number) {
		let request = this.requests.find(x => x.requestId == requestId);

		this.ngZone.run(() => {
			const dialogRef = this.dialogService.open({
				content: PlanningMapVisitComponent,
				width: '50%',
			});

			const dialog = <PlanningMapVisitComponent>dialogRef.content.instance;

			let oldSelectedPerformerIntegraCode = this.requests.find(x => x.requestId == requestId).requestPerformerUserIntegraCode;
			if (oldSelectedPerformerIntegraCode) {
				oldSelectedPerformerIntegraCode = oldSelectedPerformerIntegraCode.toLowerCase()
			}

			dialog.requestIntegraCode = request.integraCode;
			dialog.requestServiceCenterId = request.serviceCenterId;
			dialog.requestServiceCenterIntegraCode = request.serviceCenterIntegraCode;
			dialog.requestId = requestId;
			dialog.selectedPerformerIntegraCode = oldSelectedPerformerIntegraCode;
			dialog.visitDate = new Date(request.plannedDate);

			dialog.onCancelEvent.subscribe(() => {
				dialogRef.close();
			});
			dialog.onContinueEvent.subscribe((visitContext: IPlanningMapVisitContext) => {
				this.activitiesService.getById(request.activityId).subscribe(activityResp => {
					let activity = activityResp.entity;
					activity.planStartDate = visitContext.visitDate;
					activity.planStartDateLocal = visitContext.visitDate;
					activity.performerUserIntegraCode = visitContext.performerIntegraCode;
					activity.performerUserOldIntegraCode = oldSelectedPerformerIntegraCode;
					activity.performerUserId = null;
					activity.removeActivityTracking = visitContext.removeActivityTracking;
					this.activitiesService.updateExt(activity, "Заявка запланирована").subscribe(res => {
						let customerPerformerIntegraCodes = [];

						if (res.data && res.data.oldPerformerHasRoute) {
							customerPerformerIntegraCodes.push(oldSelectedPerformerIntegraCode);
						}

						if (res.data && res.data.newPerformerHasRoute && visitContext.performerIntegraCode != null && oldSelectedPerformerIntegraCode != visitContext.performerIntegraCode) {
							customerPerformerIntegraCodes.push(visitContext.performerIntegraCode);
						}

						if (visitContext.algoritmType === AlgoritmType.yandex && res.data && res.data.needCreateRoute) {
							let cancelStartPlanning$ = new Subject<void>();
							this.planningService.startPlanning(this.selectedPlannedDay, customerPerformerIntegraCodes, null, null, false, cancelStartPlanning$).subscribe(planningResp => {
								if (planningResp.isSuccessful) {
									this.planningService.confirmPlanning(planningResp.data, false).subscribe(() => {
										dialogRef.close();
										this.loadRequests(this.selectedPlannedDay, true);
									});
								} else {
									this.notificationService.error({
										title: 'Ошибка',
										message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
										notificationType: NotificationType.SweetAlert
									});
								}
							}, () => {
								this.notificationService.error({
									title: 'Ошибка',
									message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
									notificationType: NotificationType.SweetAlert
								});

								cancelStartPlanning$.next();
							});
						} else {
							dialogRef.close();
							this.loadRequests(this.selectedPlannedDay, true);
						}

						if (res.data.activityTrackingWasRemoved) {
							this.notificationService.warning({
								title: 'Внимание',
								message: 'Прежний маршрут был удален, необходимо выполнить Автоназначение за выбранный день.',
								notificationType: NotificationType.SweetAlert
							});
						}
					});
				});
			});
		});
	}
}